var render = function render(){var _vm=this,_c=_vm._self._c;return _c('device-card',{attrs:{"flat":_vm.flat,"device":_vm.device,"title":_vm.$t('device-dialog.actuators.title').toString(),"icon":"tune"}},[_c('sub-devices',[_c('actuator-device',{attrs:{"hide-actions-slot":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('nuki-opener',{attrs:{"device":_vm.device}})]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }